import type QuoteDetails from '@/services/models/QuoteDetails'
import type SchemeQuoteResult from '@/services/models/SchemeQuoteResult'
import moment from 'moment'
import Utils from './Utils'

export default class TractiveUtils extends Utils {
  coverType<T extends SchemeQuoteResult>(quote: QuoteDetails<T>, selectedSchemeQuoteResult: number): string {
    return quote.results.find(r => r.id === selectedSchemeQuoteResult)!.schemeName
  }

  getRenewalDate<T extends SchemeQuoteResult>(quote: QuoteDetails<T>): Date {
    return moment(quote.effectiveDate)
      .add(1, 'year')
      .hours(23)
      .minutes(59)
      .seconds(59)
      .toDate()
  }

  async handleBrandSwitching() {
    return this.applyYesDarkBranding()
  }

  private applyYesDarkBranding() {
    document.documentElement.classList.add('branding-dark')
  }
}
